import { render } from "./CustomerDetailTabsPanel.vue?vue&type=template&id=ca5a126a&scoped=true"
import script from "./CustomerDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./CustomerDetailTabsPanel.vue?vue&type=script&lang=js"

import "./CustomerDetailTabsPanel.vue?vue&type=style&index=0&id=ca5a126a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5a126a"]])

export default __exports__